import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import {useEffect} from "react"
import AddEditCustomPrice from "../../components/CustomPrices/addEditCustomPrice"
import AddEditCustomPriceCustomers from "../../components/CustomPrices/addEditCustomPriceCustomers"
import CustomPriceCard from "../../components/CustomPrices/customPriceCard"
import DeleteModel from "../../components/CustomPrices/deleteModel"
import AlertToastr from "../../components/Shared/alertToastr"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import {UserRegion} from "../App/models"
import {fetchCustomPrice, fetchCustomPrices, setCustomPrice} from "./customPricesSlice"

const CustomPrices = () => {
    const dispatch = useAppDispatch()
    const customPricingId = useAppSelector((state: RootState) => state.containers.customPrices.selectedCustomPricingId)
    const showManageCustomPricing = useAppSelector(
        (state: RootState) => state.containers.customPrices.showManageCustomPricing,
    )
    const selectedRegionId = useAppSelector((state: RootState) => state.containers.customPrices.selectedRegionId)
    const selectedRegion: UserRegion = useAppSelector((state: RootState) => state.application.selectedRegion)

    // fetch custom prices on load using global selected region
    useEffect(() => {
        selectedRegion && dispatch(fetchCustomPrices(selectedRegion.regionId))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    useEffect(() => {
        if (showManageCustomPricing) {
            dispatch(setCustomPrice(null))
            dispatch(fetchCustomPrice(selectedRegionId, customPricingId))
        }
    }, [selectedRegionId, customPricingId, showManageCustomPricing, dispatch])

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Settings </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Custom Pricing</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <CustomPriceCard />
            <AlertToastr />
            <AddEditCustomPriceCustomers />
            <AddEditCustomPrice />
            <DeleteModel />
        </>
    )
}

export default CustomPrices
